import AppThemeShell from "../shared/AppThemeShell";
import { useDocumentTitle } from "../shared/useDocumentTitle";
import Chart from "./Chart";

function App() {
    useDocumentTitle("Klimaomstilling - Kunnskapshuset Enova");

    return (
        <AppThemeShell color="neutral">
            <Chart />
        </AppThemeShell>
    );
}

export default App;
